// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TaskCard_wrapper_1tq_4","image":"TaskCard_image_2vJj1","title":"TaskCard_title_2lLVl","score":"TaskCard_score_2ppkq"};